module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back page-ability-step1"
  }, [_c('van-form', {
    ref: "applyForm",
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("个人能力申报")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "所属年份"
    },
    on: {
      "click": function($event) {
        _vm.showSaijiPicker = true
      }
    },
    model: {
      value: (_vm.saijiValue),
      callback: function($$v) {
        _vm.saijiValue = $$v
      },
      expression: "saijiValue"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showSaijiPicker),
      callback: function($$v) {
        _vm.showSaijiPicker = $$v
      },
      expression: "showSaijiPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.saijiColumns,
      "show-toolbar": ""
    },
    on: {
      "cancel": function($event) {
        _vm.showSaijiPicker = false
      },
      "confirm": _vm.onSaijiConfirm
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "所属场次"
    },
    on: {
      "click": function($event) {
        _vm.showSaiquPicker = true
      }
    },
    model: {
      value: (_vm.saiquValue),
      callback: function($$v) {
        _vm.saiquValue = $$v
      },
      expression: "saiquValue"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    on: {
      "open": _vm.onSaiquOpen
    },
    model: {
      value: (_vm.showSaiquPicker),
      callback: function($$v) {
        _vm.showSaiquPicker = $$v
      },
      expression: "showSaiquPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.saiquColumns,
      "show-toolbar": ""
    },
    on: {
      "cancel": function($event) {
        _vm.showSaiquPicker = false
      },
      "confirm": _vm.onSaiquConfirm
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.county ? _vm.formData.province + '/' + _vm.formData.city + '/' + _vm.formData.county : '',
      "input-align": "right",
      "label": "邮寄地区",
      "placeholder": "点击选择省市区"
    },
    on: {
      "click": function($event) {
        _vm.showArea = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area
    },
    on: {
      "confirm": _vm.onAreaConfirm,
      "cancel": function($event) {
        _vm.showArea = false
      }
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '单位名称不能为空'
      }],
      "label": "单位全称",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入单位名称"
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "联系人",
      "rules": [{
        required: true,
        message: '姓名不能为空'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.ldname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ldname", $$v)
      },
      expression: "formData.ldname"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.phone,
        message: '请输入正确的手机号'
      }],
      "error-message-align": "right",
      "label": "联系电话",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入联系电话"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '微信不能为空'
      }],
      "error-message-align": "right",
      "label": "微信",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入微信"
    },
    model: {
      value: (_vm.formData.weixin),
      callback: function($$v) {
        _vm.$set(_vm.formData, "weixin", $$v)
      },
      expression: "formData.weixin"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.email,
        message: '请输入正确的邮箱'
      }],
      "error-message-align": "right",
      "label": "邮箱",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入邮箱"
    },
    model: {
      value: (_vm.formData.email),
      callback: function($$v) {
        _vm.$set(_vm.formData, "email", $$v)
      },
      expression: "formData.email"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '地址不能为空'
      }],
      "error-message-align": "right",
      "label": "邮寄地址",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入邮寄地址"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "人员选择",
      "placeholder": "请选择人员"
    },
    on: {
      "click": function($event) {
        _vm.showYundongyuanPicker = true
      }
    }
  }), _vm._v(" "), _c('YundongyuanPicker', {
    attrs: {
      "show": _vm.showYundongyuanPicker,
      "limit": 30,
      "defaultValue": _vm.formData.yundongyuan
    },
    on: {
      "onChange": _vm.onYundongyuanChange,
      "onClose": function($event) {
        _vm.showYundongyuanPicker = false
      },
      "onConfirm": _vm.onYundongyuanConfirm
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.yundongyuan.length > 0),
      expression: "formData.yundongyuan.length>0"
    }],
    staticClass: "memberResultWrap"
  }, _vm._l((_vm.formData.yundongyuan), function(yundongyuan, index) {
    return _c('div', {
      key: index,
      staticClass: "memberLi"
    }, [_c('van-tag', {
      attrs: {
        "round": "",
        "color": "#fff",
        "text-color": "#666",
        "size": "large",
        "closeable": "",
        "type": "primary"
      },
      on: {
        "close": function($event) {
          return _vm.formData.yundongyuan.splice(index, 1)
        }
      }
    }, [_vm._v(" " + _vm._s(yundongyuan.name) + "(" + _vm._s(yundongyuan.num) + ") " + _vm._s(yundongyuan.project) + "-" + _vm._s(yundongyuan.grade) + "\n          ")])], 1)
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-footer-space"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中...",
      "native-type": "button"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("保存\n    ")])], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb0e6728","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/skill/AbilityApplyStep1.vue
// module id = 2640
// module chunks = 0